import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import Country from '../../../models/Country';
import Currency from '../../../models/Currency';
import Language from '../../../models/Language';
import { modelOf } from '../../../prop-types';
import CountryStore from '../../../store/CountryStore';
import CurrencyStore from '../../../store/CurrencyStore';
import LanguageStore from '../../../store/LanguageStore';
import RegionalSettingsCurrencyDropdown from '../RegionalSettingsCurrencyDropdown';
import RegionalSettingsDeliveryCountryDropdown from '../RegionalSettingsDeliveryCountryDropdown';
import RegionalSettingsLanguageDropdown from '../RegionalSettingsLanguageDropdown';

const RegionalSettingsDropdowns = ({
  languageStore,
  currencyStore,
  countryStore,
  country,
  language,
  currency,
  onChange,
  disabled,
}) => {
  const showCountries = countryStore.countries.length > 1;
  const showLanguages = languageStore.languages.length > 1;
  const showCurrencies = currencyStore.currencies.length > 1;

  const countryDropdown = showCountries ? (
    <RegionalSettingsDeliveryCountryDropdown
      key="country"
      country={country}
      countries={countryStore.countries}
      onSelect={(newCountry) => onChange('country', newCountry)}
      disabled={disabled}
      positionFixed
    />
  ) : null;
  const languageDropdown = showLanguages ? (
    <RegionalSettingsLanguageDropdown
      key="language"
      language={language}
      languages={languageStore.languages}
      onSelect={(newLanguage) => onChange('language', newLanguage)}
      disabled={disabled}
      positionFixed
    />
  ) : null;
  const currencyDropdown = showCurrencies ? (
    <RegionalSettingsCurrencyDropdown
      key="currency"
      currency={currency}
      currencies={currencyStore.currencies}
      onSelect={(newCurrency) => onChange('currency', newCurrency)}
      disabled={disabled}
      positionFixed
    />
  ) : null;

  const topRowDropdowns = [languageDropdown, currencyDropdown].filter(Boolean);
  const topRowHasSingleDropdown = topRowDropdowns.length === 1;

  if (topRowDropdowns.length === 0 && !countryDropdown) {
    return null;
  }

  return (
    <div className="RegionalSettingsDropdowns">
      {topRowDropdowns.length > 0 && (
        <div className="RegionalSettingsDropdowns__selector-row">
          {topRowDropdowns.map((dropdown) => (
            <div
              key={dropdown.key}
              className={`RegionalSettingsDropdowns__selector-cell${
                topRowHasSingleDropdown
                  ? ' RegionalSettingsDropdowns__selector-cell--full'
                  : ''
              }`}
            >
              {dropdown}
            </div>
          ))}
        </div>
      )}
      {countryDropdown && (
        <div className="RegionalSettingsDropdowns__selector-row RegionalSettingsDropdowns__selector-row--full">
          {countryDropdown}
        </div>
      )}
    </div>
  );
};

RegionalSettingsDropdowns.propTypes = {
  languageStore: modelOf(LanguageStore).isRequired,
  currencyStore: modelOf(CurrencyStore).isRequired,
  countryStore: modelOf(CountryStore).isRequired,
  country: modelOf(Country).isRequired,
  currency: modelOf(Currency).isRequired,
  language: modelOf(Language).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

RegionalSettingsDropdowns.defaultProps = {
  disabled: false,
};

export default inject(
  'countryStore',
  'currencyStore',
  'languageStore'
)(observer(RegionalSettingsDropdowns));
